<header class="main-header">
  <div class="container-fluid d-flex justify-content-between align-items-center h-100">
    <div class="d-flex align-items-center">
      <button class="hamburger" [class.show-on-desktop]="(isLoggedIn$ | async) && !isHomePage && !isLoginPage"
        (click)="onHamburgerClick()" aria-label="Toggle menu">
        <i class="pi pi-bars"></i>
      </button>

      <a class="logo-link" (click)="scrollToSection('home')">
        <img src="assets/images/ctc_network_logo_white.png" alt="CTC Network" class="logo">
      </a>
    </div>

    @if (isHomePage) {
      <nav class="main-nav">
        <ul class="nav-list">
          @for (item of menuItems; track item) {
            <li class="nav-item">
              <a (click)="scrollToSection(item.sectionId)" class="nav-link">{{ item.label | translate }}</a>
            </li>
          }
        </ul>
      </nav>
    }

    <div class="header-actions">
      <app-language-selector></app-language-selector>
      @if (isHomePage && !(isLoggedIn$ | async)) {
        <button (click)="goToLogin()" class="btn btn-login ms-2">
          <i class="pi pi-sign-in p-mr-2"></i>
          {{ 'header.login' | translate }}
        </button>
      }
      @if (isHomePage && (isLoggedIn$ | async)) {
        <button (click)="goToDashboard()" class="btn btn-login ms-2">
          <i class="pi pi-th-large p-mr-2"></i>
          {{ 'header.dashboard' | translate }}
        </button>
      }
    </div>
  </div>
</header>

<div class="mobile-menu" [class.is-open]="isMenuOpen">
  <div class="mobile-menu-header">
    <button class="close-btn" (click)="toggleMenu()" aria-label="Close menu">&times;</button>
  </div>
  @if (isHomePage) {
    <nav class="mobile-nav">
      <ul>
        @for (item of menuItems; track item) {
          <li>
            <a (click)="scrollToSection(item.sectionId)">{{ item.label | translate }}</a>
          </li>
        }
      </ul>
    </nav>
  }
  <div class="mobile-menu-footer">
    <app-language-selector></app-language-selector>
    @if (isHomePage && !(isLoggedIn$ | async)) {
      <button class="btn-login" (click)="goToLogin(); toggleMenu()">
        <i class="pi pi-sign-in p-mr-2"></i>
        {{ 'header.login' | translate }}
      </button>
    }
    @if (isHomePage && (isLoggedIn$ | async)) {
      <button class="btn-login" (click)="goToDashboard(); toggleMenu()">
        <i class="pi pi-th-large p-mr-2"></i>
        {{ 'header.dashboard' | translate }}
      </button>
    }
  </div>
</div>

<div class="overlay" [class.is-open]="isMenuOpen" (click)="toggleMenu()"></div>